.modalHeader {
  padding: 16px;
  height: 64px;
  min-height: 64px;
}
